"use strict";
/**
 * Defines static variables corresponding to the various formatting possibilities
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Format = void 0;
exports.Format = {
    SUBSCRIPT: 'subscript',
    SUPERSCRIPT: 'superscript',
    SUPERIMPOSE: 'superimpose',
    TEXT: 'text',
};
//# sourceMappingURL=Format.js.map